import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../themes/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import AccountProfile from "../components/AccountProfile";

export const AccountProfilePage: React.FC = () => {
    return (
        <React.Fragment>
            <AppTheme>
                <CssBaseline enableColorScheme />
                <Box
                    sx={{
                        mt: 16,
                        px: 2,
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        minHeight: "80vh",
                    }}
                >
                    <AppAppBar />
                    <AccountProfile />
                </Box>
                <Footer />
            </AppTheme>
        </React.Fragment>
    );
};

export default AccountProfilePage;